// Normalize strings for robust matching: uppercase, trim, replace dashes/underscores with spaces, collapse multiple spaces
export const normalizeString = (str) => {
  if (!str) return "";
  return str
    .toUpperCase()
    .trim()
    .replace(/[-_]/g, " ")
    .replace(/\s+/g, " ");
};

// Safe merge: always include product, enhance with spec if matches
export const mergeProductsWithSpecs = (products, specs) => {
  const ns = (v) => normalizeString(v || "");

  return products.map(product => {
    const productSegment = normalizeString(product.segment || "").toLowerCase();
    const isRudraksha =
      ns(product.productName) === "RUDRAKSHA" ||
      product.productName === "rudraksha";
    const isGemsOrPearls =
      productSegment === "gems" || productSegment === "pearls";
    const isDecor = productSegment === "decor";

    const matchers = [
      (spec) =>
        spec.segment === product.segment &&
        spec.category === product.category &&
        ns(spec.productSource) === ns(product.productSource) &&
        ns(spec.productName) === ns(product.productName) &&
        ns(spec.finishType) === ns(product.finishType),
      (spec) =>
        spec.segment === product.segment &&
        spec.category === product.category &&
        ns(spec.productSource) === ns(product.productSource) &&
        ns(spec.productName) === ns(product.productName),
      (spec) =>
        spec.segment === product.segment &&
        spec.category === product.category &&
        ns(spec.productName) === ns(product.productName) &&
        ns(spec.finishType) === ns(product.finishType),
      (spec) =>
        spec.segment === product.segment &&
        spec.category === product.category &&
        ns(spec.productName) === ns(product.productName),
    ];

    let matchingSpec = null;
    for (const match of matchers) {
      matchingSpec = specs.find(match);
      if (matchingSpec) break;
    }

    if (matchingSpec) {
      if (isRudraksha) {
        // Rudraksha: accept any spec matched by the fallback chain
      } else if (isGemsOrPearls) {
        const ok =
          matchingSpec.color &&
          product.color &&
          ns(matchingSpec.color) === ns(product.color) &&
          matchingSpec.shape &&
          product.shape &&
          ns(matchingSpec.shape) === ns(product.shape);
        if (!ok) matchingSpec = null;
      } else if (isDecor) {
        const ok =
          matchingSpec.color &&
          product.color &&
          ns(matchingSpec.color) === ns(product.color);
        if (!ok) matchingSpec = null;
      } else {
        const ok =
          matchingSpec.specification &&
          product.specification &&
          ns(matchingSpec.specification) === ns(product.specification);
        if (!ok) matchingSpec = null;
      }
    }

    return {
      ...product,
      ...(matchingSpec || {}),
      images: product.images?.length ? product.images : (matchingSpec?.images || []),
      hasSpecification: !!matchingSpec,
      specId: matchingSpec?.id || null,
      id: product.id
    };
  });
};

// Apply filters & sorting
export const applyFiltersAndSort = (productsToFilter, filters, sortConfig) => {
  let result = [...productsToFilter];

  if (filters.serviceType) {
    result = result.filter(p => p.serviceType === filters.serviceType);
  }
  if (filters.productSource) {
    result = result.filter(p => 
      normalizeString(p.productSource) === normalizeString(filters.productSource)
    );
  }

  if (sortConfig.field) {
    result = [...result].sort((a, b) => {
      let aValue = 0, bValue = 0;
      if (sortConfig.field === 'weight') {
        aValue = parseFloat(a.netWt) || 0;
        bValue = parseFloat(b.netWt) || 0;
      } else if (sortConfig.field === 'wastage') {
        aValue = parseFloat(a.wastageOperator) || 0;
        bValue = parseFloat(b.wastageOperator) || 0;
      }
      return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
    });
  }

  return result;
};